
export interface GspModule {
    id: number; // int
    name: string; // string
    serviceId: number | undefined; // int
    service: any; // adminPanel.DataAccessPostgreSQL.Database.DataModel.GspServiceDm;
    attributes: any; //System.Collections.Generic.ICollection<adminPanel.DataAccessPostgreSQL.Database.DataModel.GspAttributeDm>;
    created: string; // System.DateTime?
    creatorId: string; // string
    creatorEmail: string; // string

    isCommon: boolean; // boolean
    short_common_text: string; // string
    entra_Group: string; // string

    key: string; // string
    tooltip: string; // string
    isHideInProd: boolean; // bool

    contact_types: any;
    contactTypeIds: Array<Number> | undefined;
}

export interface Value {
  value: GspModule[];
  '@odata.context'?: string | undefined;
  '@odata.count'?: number | undefined;
}

// init api object
function toAPI(data: Partial<GspModule>): any {
  return {
    Id: data?.id || 0,
    Name: data?.name || '',
    ServiceId: data?.serviceId || 0,
    Service: data?.service || undefined,
    Attributes: data?.attributes || undefined,
    Created: data?.created || undefined,
    CreatorId: data?.creatorId || undefined,
    CreatorEmail: data?.creatorEmail || undefined,
    IsCommon: data?.isCommon || false,
    Short_common_text: data?.short_common_text || undefined,
    Entra_Group: data?.entra_Group || undefined,

    Key: data?.key ?? undefined,
    Tooltip: data?.tooltip || '',
    IsHideInProd: data?.isHideInProd || false,

    Contact_types: data?.contact_types || undefined,
    ContactTypeIds: data?.contactTypeIds || undefined,
  };
}

function parse(data?: Partial<GspModule>): GspModule {
  return {
    id: data?.id || 0,
    name: data?.name || '',
    serviceId: data?.serviceId || undefined,
    service: data?.service || '',
    attributes: data?.attributes || '',
    created: data?.created || '',
    creatorId: data?.creatorId || '',
    creatorEmail: data?.creatorEmail || '',
    isCommon: data?.isCommon || false,
    short_common_text: data?.short_common_text || '',
    entra_Group: data?.entra_Group || '',

    key: data?.key || '',
    tooltip: data?.tooltip || '',
    isHideInProd: data?.isHideInProd || false,


    contact_types: data?.contact_types || '',
    contactTypeIds: data?.contact_types ? data?.contact_types?.map((x:any) => x.id) : undefined,

  };
}

export default {
  parse,
  toAPI: toAPI,
};
